/**
 * core/easing.js
 * Các hàm nội suy toán học (Easing & Lerp) dùng cho Animation Controllers
 */

/**
 * Hàm nội suy bậc 2 làm mượt gia tốc đầu và cuối (Ease In Out Quad)
 * @param {number} x - Giá trị tiến độ từ 0.0 đến 1.0
 * @returns {number}
 */
export function easeInOutQuad(x) {
  return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
}

/**
 * Nội suy tuyến tính giữa 2 số thực
 * @param {number} a - Giá trị bắt đầu
 * @param {number} b - Giá trị đích
 * @param {number} t - Tỷ lệ (0.0 đến 1.0)
 * @returns {number}
 */
export function lerp(a, b, t) {
  return a + (b - a) * t;
}

/**
 * Nội suy toàn bộ bản đồ tư thế khớp (Pose Object) giữa 2 trạng thái
 * @param {object} from - Tư thế ban đầu
 * @param {object} to - Tư thế đích
 * @param {number} t - Tỷ lệ nội suy đã làm mượt
 * @returns {object} Tư thế nội suy
 */
export function lerpPose(from, to, t) {
  const res = {};
  for (const key of Object.keys(from)) {
    res[key] = lerp(from[key] || 0, to[key] || 0, t);
  }
  return res;
}
